import { BaseEntity } from "yt-ng-framework";
export class FakDokumentUplataView extends BaseEntity{
    constructor(){
        super();
    }

    Datum: Date = null;
    Iznos: number;
    BrojIzvoda: string;
    RedniBroj:number

    Deserialize(input: any) {
        this.ID=input.ID;
        this.Datum=input.Datum;
        this.Iznos=input.Iznos;
        this.BrojIzvoda = input.BrojIzvoda;
        this.RedniBroj = input.RedniBroj;
        return this
    }

    Serialize(input:FakDokumentUplataView){
        return input;
    }

}